module.exports = __webpack_public_path__ + "img/jyb-banner.5dd48677.png";